import { render, staticRenderFns } from "./WxEditor.vue?vue&type=template&id=df7bfcf4"
import script from "./WxEditor.vue?vue&type=script&lang=js"
export * from "./WxEditor.vue?vue&type=script&lang=js"
import style0 from "./WxEditor.vue?vue&type=style&index=0&id=df7bfcf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports